import fetch from '@/plugins/fetch'
import utils from '@/plugins/utils'
import queryString from 'query-string'
import { PREFIX_SCOUPON_API } from '@/service'
const api = {
  getCoupon: PREFIX_SCOUPON_API + 'userCoupon/sendCoupon.do',
  getConfirmCoupon: PREFIX_SCOUPON_API + 'userCoupon/getBestUserCouponList.do'
}

export default {
  async userGetCoupon({ commit, state }, { couponCode, uid, skey }) {
    try {
      const query = queryString.stringify({
        couponCode,
        uid,
        skey
      })
      const res = await fetch(`${api.getCoupon}?${query}`)
      const json = await res.json()
      return json
    } catch (e) {
      throw new Error(e.message)
    }
  },
  async getCoupon4Confirm(
    { commit, state },
    { uid, skey, spuId, sortType, price, skuId, shopId, sourceType }
  ) {
    try {
      const query = queryString.stringify({
        uid,
        skey,
        spuId,
        sortType,
        price,
        skuId,
        shopId,
        sourceType
      })
      const res = await fetch(`${api.getConfirmCoupon}?${query}`)
      const json = await res.json()
      return json
    } catch (e) {
      throw new Error(e.message)
    }
  }
}
